module.exports = __webpack_public_path__ + "static/media/vr12.8e0c9230.jpg";